import { withInstall } from '@jdesign-vue/utils'
import TreeV2 from './src/tree.vue'

export const JdTreeV2 = withInstall(TreeV2)
export default JdTreeV2
